var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconJs48Line = function SvgIconJs48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 38.7H14.6a5.31 5.31 0 0 1-5.3-5.3V14.6c0-2.92 2.38-5.3 5.3-5.3h18.8c2.92 0 5.3 2.38 5.3 5.3v18.8c0 2.92-2.38 5.3-5.3 5.3Zm-18.8-26a1.9 1.9 0 0 0-1.9 1.9v18.8c0 1.05.85 1.9 1.9 1.9h18.8a1.9 1.9 0 0 0 1.9-1.9V14.6a1.9 1.9 0 0 0-1.9-1.9H14.6Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.68 26.72c-.81-.22-1.51-.4-1.51-.79 0-.43.63-.44.7-.44.23 0 .78.07.78.71h3.36c0-2.41-1.54-3.85-4.11-3.85-2.57 0-4.14 1.37-4.14 3.67 0 2.69 2.04 3.24 3.58 3.65.94.24 1.52.42 1.52.83s-.43.63-.87.63-.92-.22-.92-.86v-.22h-3.44v.22c0 2.52 1.68 4.08 4.37 4.08 2.69 0 4.34-1.5 4.34-3.91 0-2.71-2.11-3.29-3.66-3.72ZM20.63 34.32c-2.2 0-3.98-1.79-3.98-3.98v-.29h3.4v.29a.58.58 0 0 0 1.16 0v-7.72h3.4v7.72c0 2.2-1.79 3.98-3.98 3.98Z",
    fill: "current"
  })));
};
export default SvgIconJs48Line;